import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { CompanyPickerModule } from '../company-picker/company-picker.module';
import { CompaniesPickerComponent } from './companies-picker.component';

@NgModule({
    imports: [
        CompanyPickerModule,
        CommonModule,
        MatChipsModule,
        MatIconModule,
        ReactiveFormsModule
    ],
    declarations: [
        CompaniesPickerComponent
    ],
    exports: [
        CompaniesPickerComponent
    ]
})
export class CompaniesPickerModule {
}
